import { html, on, rune, View } from 'rune-ts';
import klass from './PortfolioSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { ButtonAction } from '../../../../../shared/components/atoms/ButtonAction/ButtonAction';
import { ArrowRightIcon } from '../../../../components/atoms/Icon';
import { getResizedUrl } from '../../../../../shared/util/image';

export class PortfolioSection extends View {
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      portfolio_title: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}portfolio_title`),
      ),
      portfolio_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}portfolio_description`),
      ),
      portfolio_button: html` ${ET(
        `mps2::landing::plus::${is_mobile ? 'mo_' : ''}portfolio_button`,
      )}${ArrowRightIcon}`,
    };

    return html`
      <section class="${klass.container}">
        <img
          class="${klass.bg}"
          src="${getResizedUrl({
            url: '//s3.marpple.co/files/u_14345/2024/6/original/plus/section8/background.png',
            width: 1920 * 2,
            format: 'webp',
            quality: 85,
          })}"
          alt="ip 커머스 예시 모바일 이미지"
        />
        <div class="${klass.title_wrapper}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.portfolio_title}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '14_medium' })}">
            ${texts.portfolio_description}
          </div>
          ${new ButtonAction({
            label: texts.portfolio_button,
            size: is_mobile ? 'medium' : 'large',
            klass: klass.button,
            type: 'blue',
          })}
        </div>
      </section>
    `;
  }

  @on('click', `.${klass.button}`)
  clickMoreButton() {
    window.open(`/${T.lang}/@/creator/plus`);
  }
}
